import { isDefined } from "@clipboard-health/util-ts";

/**
 * Checks if profile should be considered completed for placement details page.
 * Profile is completed if any of these conditions are met:
 * - Profile is actually completed
 * - Highest ranking shared qualification is auto-approved
 * - Any placement worker type is auto-approved
 */
export function checkIsProfileCompletedForPlacement(
  isProfileCompleted: boolean,
  highestRankingSharedQualification: string | undefined,
  placementWorkerTypes: string[] | undefined,
  autoApprovedQualifications: Set<string>
): boolean {
  return (
    isProfileCompleted ||
    (isDefined(highestRankingSharedQualification) &&
      autoApprovedQualifications.has(highestRankingSharedQualification)) ||
    (isDefined(placementWorkerTypes) &&
      placementWorkerTypes.some((wt) => autoApprovedQualifications.has(wt)))
  );
}
